var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6"},[_c('div',{staticClass:"mb-4"},[_c('UpdateLoans',{attrs:{"staffs":_vm.staffs,"details":_vm.loanDetails},on:{"clicked":_vm.onClickChild}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }